import CampaignsTitleBar from './TitleBar'
export default CampaignsTitleBar
